import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { setMeta } from '../utils/seo';
import { SeoBreadcrumbs, SeoRelatedLinks } from '../components/SeoPageBlocks';
import guidesContent from '../data/guidesContent';

const PUBLISHED_DATE = '2026-04-25';
const UPDATED_DATE = '2026-04-25';

const ARTICLE_META = {
  'texas-beginner': {
    articleKey: '竞技扑克新手入门规则',
    title: '德州扑克新手入门规则详解_HHpoker竞技扑克',
    description: '德州扑克游戏流程、牌型大小和新手起手牌策略完整讲解，HHpoker竞技扑克入门必读指南。',
    keywords: '德州扑克新手入门, 德州扑克规则, 德扑牌型大小, HHpoker入门, 德州扑克游戏流程',
    label: '德州扑克新手入门规则详解'
  },
  'omaha': {
    articleKey: '奥马哈Omaha竞技详解',
    title: '奥马哈Omaha玩法规则与进阶策略_HHpoker',
    description: '奥马哈扑克核心规则、起手牌选择与坚果牌思维详解，HHpoker Omaha竞技全面入门指南。',
    keywords: '奥马哈规则, Omaha玩法, 奥马哈坚果牌, HHpoker奥马哈, 奥马哈起手牌',
    label: '奥马哈Omaha竞技详解'
  },
  'position-strategy': {
    articleKey: '进阶攻略：位置的重要性',
    title: '德州扑克位置攻略_前位中位后位策略详解',
    description: '德州扑克位置就是金钱，详解前位EP、中位MP、后位LP的策略差异和实战应用技巧。',
    keywords: '德州扑克位置, 德扑前位中位后位, BTN位置策略, 德扑位置优势, 德扑进阶攻略',
    label: '德州扑克位置策略进阶攻略'
  },
  'bankroll-management': {
    articleKey: '积分管理：如何长期提升战绩',
    title: '德州扑克资金管理BRM指南_长期稳健盈利方法',
    description: '扑克资金管理黄金法则，买入量原则、止损设定和级别升降策略，竞技扑克长期稳健盈利必修课。',
    keywords: '德扑资金管理, BRM, 扑克止损, 德扑买入量, 长期盈利德州扑克',
    label: '德州扑克资金管理BRM指南'
  },
  'cowboy-rules': {
    articleKey: '竞技牛仔玩法介绍',
    title: '德扑圈牛仔玩法规则详解_HHpoker特色玩法',
    description: '德扑圈牛仔玩法各类特色规则介绍，包括换牌卡、保险机制、多板玩法和72赏金机制，HHpoker特色玩法攻略。',
    keywords: '牛仔玩法, HHpoker牛仔, 德扑换牌卡, 德扑保险机制, 德扑多板玩法',
    label: '德扑圈牛仔玩法规则详解'
  },
  'poker-tells': {
    articleKey: '如何识别和利用对手的马脚',
    title: '德州扑克读牌技巧_识别线上马脚与行动时间Tell',
    description: '线上德扑马脚识别技巧，行动时间tell、下注尺度tell分析，HUD数据应用与剥削策略完整指南。',
    keywords: '德扑读牌, 扑克马脚, timing tell, 下注尺度, HUD数据, 德扑剥削策略',
    label: '德扑读牌技巧：识别马脚指南'
  }
};

const relatedLinks = [
  { to: '/guide', text: '扑克攻略中心' },
  { to: '/texas-poker-complete-guide', text: '德州扑克完整规则教程' },
  { to: '/download', text: 'HHpoker下载' }
];

function GuideArticle({ slug }) {
  const meta = ARTICLE_META[slug];

  useEffect(() => {
    if (!meta) return;
    setMeta({
      title: meta.title,
      description: meta.description,
      keywords: meta.keywords,
      url: window.location.origin + `/guide/${slug}/`,
      robots: 'index,follow',
      image: window.location.origin + '/images/banner.jpg',
      jsonLd: {
        '@context': 'https://schema.org',
        '@graph': [
          {
            '@type': 'Article',
            headline: meta.title,
            description: meta.description,
            datePublished: PUBLISHED_DATE,
            dateModified: UPDATED_DATE,
            author: { '@type': 'Organization', name: 'HHpoker攻略' }
          },
          {
            '@type': 'BreadcrumbList',
            itemListElement: [
              { '@type': 'ListItem', position: 1, name: '首页', item: window.location.origin + '/' },
              { '@type': 'ListItem', position: 2, name: '扑克攻略', item: window.location.origin + '/guide/' },
              { '@type': 'ListItem', position: 3, name: meta.label }
            ]
          }
        ]
      }
    });
  }, [slug, meta]);

  if (!meta) {
    return (
      <div style={{ background: '#1a1c29', color: '#fff', minHeight: '100vh', padding: '80px 20px', textAlign: 'center' }}>
        <h1 style={{ color: '#efa765' }}>文章未找到</h1>
        <Link to="/guide" style={{ color: '#efa765' }}>返回攻略中心</Link>
      </div>
    );
  }

  const content = (guidesContent[meta.articleKey] || []).join('');

  return (
    <div style={{ background: '#1a1c29', color: '#fff', minHeight: '100vh', padding: '80px 20px' }}>
      <div style={{ maxWidth: '920px', margin: '0 auto', lineHeight: 1.8 }}>
        <SeoBreadcrumbs currentLabel={meta.label} />
        <p style={{ color: '#a9afbc', fontSize: '0.9rem' }}>发布时间：{PUBLISHED_DATE} ｜ 更新时间：{UPDATED_DATE}</p>
        <div
          dangerouslySetInnerHTML={{ __html: content }}
          style={{ lineHeight: 1.9 }}
        />
        <SeoRelatedLinks links={relatedLinks} />
      </div>
    </div>
  );
}

export default GuideArticle;
